import { render, staticRenderFns } from "./continuos.vue?vue&type=template&id=156102d3"
import script from "./continuos.ts?vue&type=script&lang=js&external"
export * from "./continuos.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156102d3')) {
      api.createRecord('156102d3', component.options)
    } else {
      api.reload('156102d3', component.options)
    }
    module.hot.accept("./continuos.vue?vue&type=template&id=156102d3", function () {
      api.rerender('156102d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/home/fastaction/continuos/continuos.vue"
export default component.exports